import { ReactNode } from 'react';
import { Card } from '@/components/ui/card';

interface PreviewCardShellProps {
  badge: ReactNode;
  label: string;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
  badgeClassName?: string;
}

export const PreviewCardShell = ({
  badge,
  label,
  children,
  className = '',
  bodyClassName = '',
  badgeClassName = '',
}: PreviewCardShellProps) => {
  return (
    // Header uses custom #1e1e22 (slightly lighter than zinc-950) for subtle differentiation from body
    <Card className={`overflow-hidden border-white/10 bg-[#1e1e22] text-zinc-50 ${className}`}>
      <div className={`flex items-center gap-2 px-3 py-1.5 ${badgeClassName}`}>
        {badge}
        <span className="text-xs font-semibold text-white">{label}</span>
      </div>
      <div className={`bg-zinc-950 text-zinc-50 ${bodyClassName}`}>
        {children}
      </div>
    </Card>
  );
};
